import styled from "styled-components";
import {
  blue,
  green,
  lightblue,
  lightorange,
  orange,
} from "../../styles/variables.style";

export const ArticleWrapper = styled.div`
  .titleWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;

    h1 {
      font-size: 42px;
      font-weight: bold;
    }
  }

  .divider {
    width: 400px;
    height: 4px;
    background: ${blue};
    border: none;
    margin-top: 10px;
    margin-bottom: 25px;
  }

  .mainTitle {
    font-size: 34px;
    margin-bottom: 0px;
  }

  p.mainTitle {
    margin-bottom: 20px;
  }

  h2 {
    font-size: 30px;
  }

  h3 {
    font-size: 20px;
  }

  h4 {
    padding-left: 10px;
    font-style: italic;
  }

  .coverPic {
    width: 100%;
    max-height: 400px;
    border-radius: 5px;
    object-fit: cover;
  }

  .articleContent,
  .writterWrapper {
    a {
      color: ${blue};
      font-weight: bold;
    }
  }

  .sticky {
    min-width: 302px;
    .ant-anchor-ink {
      display: none;
    }
    .ant-anchor-wrapper {
      overflow-y: hidden;
      > div {
        > div {
          padding: 10px;
          border-radius: 10px;
          box-shadow: 0 0 5px lightgrey;
          width: 300px;
          margin-bottom: 20px;
          &.stickySummary {
            text-align: right;
            border: 1px solid ${blue};
            .ant-anchor-link {
              margin: 0px;
            }
            .ant-anchor-link-title-active {
              color: ${blue};
              font-weight: bold;
            }
            strong {
              color: ${blue};
              font-size: 22px;
            }
            a {
              height: 20px;
            }
            font-size: 14px;
            text-align: right;
            padding-left: 10px;
            > div {
              margin-bottom: 10px;
            }
            .links {
              display: flex;
              justify-content: flex-end;
              svg {
                font-size: 32px;
              }
            }
            .fb {
              color: #3c5a99;
            }
            .lk {
              color: #0274b3;
            }
          }

          &.stickyLastArticles {
            border: 1px solid ${orange};
            background: ${lightorange};
            text-align: center;
            font-weight: bold;
            strong {
              font-size: 18px;
            }
            hr {
              background: ${orange};
              border: none;
              height: 2px;
              width: 84%;
            }
            img {
              height: 70px;
              width: 100%;
              object-fit: cover;
            }
            a {
              &:hover {
                color: black;
              }
            }
            .lastArticle {
              padding: 0px 8%;
              height: 140px;
              a {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              p {
                margin: 0px;
              }
              &:hover {
                padding: 0px 2%;
                p {
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
    }
  }

  .articleContentWrapper {
    display: flex;
    padding: 20px 20%;
  }

  .articleContent {
    padding-right: 50px;
    h2,
    h3,
    h4,
    p,
    strong {
      ${"" /* font-family: filson-pro, sans-serif; */}
    }

    .htmlContent {
      img {
        height: 200px;
        width: 100%;
        object-fit: cover;
      }
      p,
      li {
        text-align: justify;
        font-size: 18px;
      }
      ${
        "" /* strong {
        color: ${lightblue};
      } */
      }
      h2 > strong {
        color: ${blue} !important;
      }
    }

    .contentHeader {
      display: flex;
      justify-content: space-between;
      > div {
        flex: 1;
      }
      .tags {
        flex: 2;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        > div {
          margin-top: 5px;
        }
      }
      .readingTime {
        font-style: italic;
      }
    }

    .writterWrapper {
      padding-top: 50px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      p {
        margin: 0px;
        &.share {
          display: flex;
          align-items: center;
        }
      }
      svg {
        font-size: 22px;
        margin-left: 5px;
      }
    }

    .table {
      box-shadow: 0px 0px 10px gainsboro;
      border-radius: 10px;
      td {
        border: 1px solid gainsboro;
        padding: 5px;
      }
    }
    &.placement-financier-eco-responsable-lisr {
      table {
        img {
          width: 100px;
        }
      }
    }
  }

  .otherArticles {
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      display: flex;
      flex-wrap: wrap;
      > div {
        margin-right: 5px;
        margin-left: 5px;
      }
    }
  }

  .summary {
    a {
      color: black;
      &:hover {
        color: ${blue};
      }
    }
    h3 {
      font-weight: bold;
    }
    text-align: right;
  }

  @media (max-width: 1024px) {
    padding-left: 3%;
    padding-right: 3%;
    .articleContentWrapper {
      padding: 0px;
    }
    .sticky {
      display: none;
    }
    .titleWrapper {
      padding-top: 30px;
    }
    .divider {
      width: 90%;
    }
    .articleContent {
      padding: 0px;
      padding-top: 10px;
      .links {
        position: relative;
        flex-direction: row;
        left: 0px;
      }
      .contentHeader {
        flex-direction: column;
        .tags {
          justify-content: flex-start;
        }
      }
      p {
        margin: 0px;
      }
      h2 {
        line-height: 35px;
        font-size: 24px;
      }
      .table {
        overflow: auto;
        width: 100%;
        margin: 0px;
      }
      &.placement-financier-eco-responsable-lisr {
        table {
          img {
            width: 100px;
          }
          tbody tr td:first-child {
            display: none;
          }
        }
      }
    }
  }
`;
